class TransactionDocument {
  referenceNumber: string;
  fileName: string;
  fileDescription: string;
  fileSn: number;
  constructor(referenceNumber: string, fileName: string, fileDescription: string, fileSn: number) {
    this.referenceNumber = referenceNumber;
    this.fileName = fileName;
    this.fileDescription = fileDescription;
    this.fileSn = fileSn;
  }
}

export { TransactionDocument };
